import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import CurrencyInput from 'react-currency-input';
import MaskedInput from 'react-text-mask';
import {
  Button, Col, DatePicker, Input, message, Modal,
  Row, Select, Spin, Form, Checkbox, Alert,
  notification,
} from 'antd';
import {
  DeleteFilled,
  WarningOutlined,
} from '@ant-design/icons';
import {
  get, put, post, RequestWrapper,
  ResponseWrapper, isSuperAgentError,
} from '../../../dataSource/requests';
import './EditService.scss';
import SelectedLands from '../serviceComponents/selectedLands/SelectedLands';
import DynamicFields from '../../sharedComponents/dynamicFields/DynamicFields';
import { getUserType, getUserInfoOnLocalStorage } from '../../../utils/users';
import ServiceStatusComponent from '../../sharedComponents/serviceStatusComponent/ServiceStatusComponent';
import GridFields from '../serviceComponents/gridFields/GridFields';
import UploadFiles from '../serviceComponents/uploadFiles/UploadFiles';
import ServiceRequestFieldsRenderer from '../serviceComponents/serviceRequestFields/ServiceRequestFields';
import { formatTelephone } from '../../../utils/format';
import { isRestructuredService } from '../../../utils/constants';

const dateFormat = 'DD/MM/YYYY';

const EditService = (): JSX.Element => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formInstance] = Form.useForm();
  const [formInstanceReason] = Form.useForm();
  const uploadFilesReference = useRef(null);
  const uploadAttachmentReports = useRef(null);
  const { TextArea } = Input;

  const [visibleModalStatus, setVisibleModalStatus] = useState<boolean>(false);
  const [userType] = useState<string | null>(getUserType());
  const [serviceTypeDynamicFields, setServiceTypeDynamicFields] = useState([]);
  const [serviceSubtypeDynamicFields, setServiceSubtypeDynamicFields] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [visibleModalResponsable, setVisibleModalResponsable] = useState<boolean>(false);
  const [formValueTemp, setFormValueTemp] = useState([]);
  const [generatedNumbers, setGeneratedNumbers] = useState([]);
  const [dataAttachments, setDataAttachments] = useState([]);
  const [dataId, setDataId] = useState(null);
  const [dataLandFields, setDataLandFields] = useState([]);
  const [dataLandName, setDataLandName] = useState<string | null>(null);
  const [dataLandOwnerName, setDataLandOwnerName] = useState<string | null>(null);
  const [dataMatriculationNumber, setDataMatriculationNumber] = useState<string | null>(null);
  const [dataReasonForCancellation, setDataReasonForCancellation] = useState<string | null>(null);
  const [hasSubType, setHasSubType] = useState(null);
  const [serviceRequestFields, setServiceRequestFields] = useState([]);
  const [allRequestData, setAllRequestData] = useState({});
  const [estimateValues, setEstimateValues] = useState([]);
  const [emptyValues, setEmptyValues] = useState([]);
  const [emptyValueObs, setEmptyValueObs] = useState([]);
  const [estimatesIds, setEstimatesIds] = useState([]);
  const [isRestructured, setIsRestructured] = useState<boolean>(false);

  const [dataTelephone, setDataTelephone] = useState<string | null>(null);

  const [dataResponsableUser, setDataResponsableUser] = useState({
    id: null,
    name: null,
  });
  const [responsableUserBudgetName, setResponsableUserBudgetName] = useState<string>('');
  const [userId, setUserId] = useState<string>('');
  const [dataSchedulingDate, setDataSchedulingDate] = useState({
    dynamicFieldId: null,
    id: null,
    name: null,
    value: null,
  });

  const [dataServiceName, setDataServiceName] = useState<string | null>(null);
  const [dataServiceSubtype, setDataServiceSubtype] = useState({
    id: null,
    name: null,
  });

  const [dataServiceSubtypeDynamicFields, setDataServiceSubtypeDynamicFields] = useState([]);
  const [dataServiceType, setDataServiceType] = useState({
    id: null,
    name: null,
  });

  const [dataServiceTypeDynamicFields, setDataServiceTypeDynamicFields] = useState([]);
  const [dataSolicitationDateTime, setDataSolicitationDateTime] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [technicalDateAllocated, setTechnicalDateAllocated] = useState(null);

  const [
    dataUserNameThatRequestedTheService,
    setDataUserNameThatRequestedTheService,
  ] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [statusesList, setStatusesList] = useState([]);
  const [currentStatusIndex, setCurrentStatusIndex] = useState<number>(0);
  const [canceled, setCanceled] = useState<boolean>(false);
  const [obsArrayInit, setObsArrayInit] = useState([]);
  const [obsArray, setObsArray] = useState([]);
  const [hasNotPrivate, setHasNotPrivate] = useState<boolean>(false);
  const valueAttachmentSizeCooperated = useRef(null);
  const valueAttachmentSizeCoopercitrus = useRef(null);
  const [ctcResponsavel, setCTCResponsavel] = useState(null);
  const [nomeFilial, setNomeFilial] = useState<string | null>(null);

  useEffect(() => {
    let has = false;
    for (const key in obsArray) {
      if (!obsArray[key].privateNotes && obsArray[key].type === 'COOPERCITRUS') {
        has = true;
      }
    }
    setHasNotPrivate(has);
  }, [JSON.stringify(obsArray)]);

  useEffect(() => {
    formInstance.setFieldsValue(
      estimateValues,
    );
    if (estimateValues.valorUnitario == null
      || estimateValues.valorUnitario == ''
    ) {
      setEmptyValues(true);
    } else {
      setEmptyValues(false);
    }
    if (estimateValues.obsOrcamento == null
      || estimateValues.obsOrcamento == ''
    ) {
      setEmptyValueObs(true);
    } else {
      setEmptyValueObs(false);
    }
  }, [estimateValues]);

  const dataShare = {
    attachments: dataAttachments,
    id: dataId,
    landFields: dataLandFields,
    landName: dataLandName,
    landOwnerName: dataLandOwnerName,
    matriculationNumber: dataMatriculationNumber,
    reasonForCancellation: dataReasonForCancellation,
    responsableUser: dataResponsableUser,
    schedulingDate: dataSchedulingDate,
    serviceName: dataServiceName,
    telephone: dataTelephone,
    serviceSubtype: dataServiceSubtype,
    serviceSubtypeDynamicFields: dataServiceSubtypeDynamicFields,
    serviceType: dataServiceType,
    serviceTypeDynamicFields: dataServiceTypeDynamicFields,
    solicitationDateTime: dataSolicitationDateTime,
    status: dataStatus,
    userNameThatRequestedTheService: dataUserNameThatRequestedTheService,
  };

  const reorder = (arrayOfFields) => {
    const fields = arrayOfFields;

    function insertAt(array, index, a): void {
      array.splice(index, 0, a);
    }

    let newFields = [];

    if (fields.length > 0) {
      newFields = fields.filter((field) => field.conditionFieldId == null);
      newFields.sort((a, b) => a.id < b.id);

      let haveFieldToBeSorted = true;

      while (haveFieldToBeSorted) {
        haveFieldToBeSorted = false;

        for (let iCount = fields.length - 1; iCount >= 0; iCount--) {
          const field = fields[iCount];

          if (field.conditionFieldId != null) {
            const indexDependencyField = newFields
              .filter((field1) => field1.id == field.conditionFieldId);

            if (indexDependencyField.length === 0) {
              haveFieldToBeSorted = true;
            } else if (!newFields.includes(field)) {
              const indexDependencyFieldIndex = newFields.indexOf(indexDependencyField[0]);

              insertAt(newFields, indexDependencyFieldIndex + 1, field);
            }
          }
        }
      }
    }
    return newFields;
  };

  const testConditional = (referenceValue, comparison, expectedValue, type) => {
    if (type === 'LONG') { }

    if (type === 'BOOLEAN') { }

    if (type === 'DATE') { }

    if (type === 'STRING') { }

    if (comparison === 'IN') {
      const objExpected = JSON.parse(expectedValue);
      return objExpected.some((obj) => obj === referenceValue);
    }

    if (comparison === 'EQUAL') {
      return referenceValue?.toString() === expectedValue?.toString();
    }

    if (comparison === 'GREATER') {
      return referenceValue > expectedValue;
    }

    if (comparison === 'GREATER_EQUAL') {
      return referenceValue >= expectedValue;
    }

    if (comparison === 'LESS') {
      return referenceValue < expectedValue;
    }

    if (comparison === 'LESS_EQUAL') {
      return referenceValue <= expectedValue;
    }

    if (comparison === 'BETWEEN') {
      const expectedValueArray = expectedValue.split(';');
      return referenceValue <= expectedValueArray[0] && expectedValueArray[1] <= referenceValue;
    }

    return true;
  };

  const mask = (rawValue): (string | RegExp)[] => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getValueSystemParameters = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const getSystemParametersReqRef: RequestWrapper = get({
        url: '/system/getSystemParameters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await getSystemParametersReqRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 8001):
        // "System parameters got successfully", 8001
        valueAttachmentSizeCooperated.current = response?.body
          .getSystemParametersOutput
          .attachmentSizeCooperated;

        valueAttachmentSizeCoopercitrus.current = response?.body
          .getSystemParametersOutput
          .attachmentSizeCoopercitrus;
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Ocorreu um erro ao buscar informações, tente novamente.',
        });
        break;
    }
  };

  const validateBudgetValues = (): Promise<void> => {
    let empty = 0;
    if (formInstance.getFieldValue('valorTotal') == null
      || formInstance.getFieldValue('valorTotal') == ''
    ) {
      empty++;
    }
    if (formInstance.getFieldValue('valorUnitario') == null
      || formInstance.getFieldValue('valorUnitario') == ''
    ) {
      empty++;
    }
    if (formInstance.getFieldValue('condicaoPagamento') == null
      || formInstance.getFieldValue('condicaoPagamento') == ''
    ) {
      empty++;
    }
    if (formInstance.getFieldValue('formaPagamento') == null
      || formInstance.getFieldValue('formaPagamento') == ''
    ) {
      empty++;
    }
    if (empty > 0 && empty < 4) {
      return Promise.reject(
        new Error('erro de validação nos campos de orçamento'),
      );
    }

    return Promise.resolve();
  };

  useEffect(() => {
    formInstance.setFieldsValue({ responsableUser: dataResponsableUser?.id });
  }, [dataResponsableUser],
  );

  useEffect(() => {
    const info = getUserInfoOnLocalStorage();
    setUserId(info.id);

    return () => {
      setLoading(false);
    };
  }, []);

  useEffect(() => {
    getValueSystemParameters();

    const loadTypeDynamicFields = async (idArgument): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const typeDynamicFieldRequestReference: RequestWrapper = get({
          url: `/service/typeDynamicField/${idArgument}`,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await typeDynamicFieldRequestReference;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 5001): {
          // "Dynamic fields listed successfully", 5001
          const dynamicReordered = reorder(response?.body.serviceTypeDynamicFields);
          setServiceTypeDynamicFields(dynamicReordered);
        } break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        default:
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar os campos do serviço, tente novamente',
          });
          break;
      }
    };

    const loadSubtypeDynamicFields = async (idArgument, idCultura): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      const subtypeDynamicFieldReqRef: RequestWrapper = get({
        url: `/service/subtypeDynamicField/${idArgument}/${idCultura}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      try {
        response = await subtypeDynamicFieldReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 5001): {
          // "Dynamic fields listed successfully", 5001
          const dynamicReordered = reorder(response?.body.serviceSubtypeDynamicFields);
          setServiceSubtypeDynamicFields(dynamicReordered);
        } break;

        case (responseError?.body?.code === -5003):
          // "Service subtype not found", -5003
          notification.error({
            message: 'Erro',
            description: 'Subtipo de serviço não encontrado.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar os campos do serviço, tente novamente',
          });
          break;
      }
    };

    const loadResponsableUser = async (): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      const adminFindAllActivatedReqRef: RequestWrapper = get({
        url: '/admin/findAllActivated',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      try {
        response = await adminFindAllActivatedReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 1009):
          // "All users listed successfully", 1009
          setUserOptions(response?.body.coopercitrusUsers.map(
            (v) => (
              <Select.Option
                key={v.id}
                value={v.id}
              >
                {v.name}
              </Select.Option>
            ),
          ));
          break;

        case (responseError?.body?.code === -1007):
          // "User not found", -1007
          notification.error({
            message: 'Erro',
            description: 'Usuário não encontrado.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Erro ao carregar a listagem de usuários responsáveis',
          });
          break;
      }
    };

    const loadStatusData = async (idArgument): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      const getServiceStatusFlowReqRef: RequestWrapper = get({
        url: `/service/getServiceStatusFlow/${idArgument}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      try {
        response = await getServiceStatusFlowReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 5009): {
          // "Service flow listed successfully", 5009
          const statusesListResponse = response?.body.serviceStatusFlowOutputs;
          setStatusesList(statusesListResponse);
          setCurrentStatusIndex(statusesListResponse.reduce((a, v) => (a + !!v.date), -1));
          setCanceled(!!statusesListResponse.find((v) => v.reasonForCancellation));
        } break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -5008):
          // "Service request not found", -5008
          notification.error({
            message: 'Erro',
            description: 'Solicitação de serviço não encontrada.',
          });
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar o fluxo de status, tente novamente',
          });
          break;
      }
    };

    const loadData = async (idArgument): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      setLoading(true);

      const findServiceRequestReqRef: RequestWrapper = get({
        url: `/service/findServiceRequest/${idArgument}`,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      try {
        response = await findServiceRequestReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      setLoading(false);

      switch (true) {
        case (response?.body?.code === 5006): {
          // "Service request found successfully", 5006
          setAllRequestData(response?.body.details);
          if (!response?.body.details.budgetId && userType === 'COOPERCITRUS') {
            if (
              (
                response?.body.details?.serviceName?.toUpperCase() === 'GEOFERT'
                || response?.body.details?.serviceName === 'Pós-vendas'
              ) && response?.body.details?.serviceRequestFields?.filter((v) => v.name.includes('Valor unitário')).length > 0
            ) {
              setEstimatesIds(
                {
                  VALOR_UNITARIO: response?.body.details.serviceRequestFields.find(
                    (v) => v.name.includes('Valor unitário'))?.idCode,
                  VALOR_TOTAL: response?.body.details.serviceRequestFields.find(
                    (v) => v.name.includes('Valor total'))?.idCode,
                  CONDICAO_PAGAMENTO: response?.body.details.serviceRequestFields.find(
                    (v) => v.name.includes('Condição de pagamento')).idCode,
                  FORMA_PAGAMENTO: response?.body.details.serviceRequestFields.find(
                    (v) => v.name.includes('Forma de pagamento'))?.idCode,
                  OBSERVACOES: response?.body.details.serviceRequestFields.find(
                    (v) => v.name.includes('Observações do orçamento'))?.idCode,
                },
              );
              setEstimateValues({
                valorUnitario: response?.body.details.serviceRequestFields.find(
                  (v) => v.name.includes('Valor unitário'))?.value?.toString().replaceAll('.', ','),
                valorTotal: response?.body.details.serviceRequestFields.find(
                  (v) => v.name.includes('Valor total'))?.value?.toString().replaceAll('.', ','),
                condicaoPagamento: response?.body.details.serviceRequestFields.find(
                  (v) => v.name.includes('Condição de pagamento'))?.value,
                formaPagamento: response?.body.details.serviceRequestFields.find(
                  (v) => v.name.includes('Forma de pagamento'))?.value,
                obsOrcamento: response?.body.details.serviceRequestFields.find(
                  (v) => v.name.includes('Observações do orçamento'))?.value,
              });
            }
            if (
              (
                response?.body.details?.serviceName === 'Satélite'
                || response?.body.details?.serviceName === 'Vant'
                || response?.body.details?.serviceName === 'Aplicação de corretivos'
                || response?.body.details?.serviceName === 'Spray Drone'
              ) && (
                response?.body.details?.serviceSubtypeDynamicFields?.filter((v) => v.name.includes('Valor unitário')).length > 0
                || response?.body.details?.serviceTypeDynamicFields?.filter((v) => v.name.includes('Valor unitário')).length > 0
              )
            ) {
              if (response?.body.details?.serviceType.name === 'Aplicação em área de catação') {
                setEstimatesIds({
                  VALOR_UNITARIO: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Valor unitário')?.id,
                  VALOR_TOTAL: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Valor total')?.id,
                  CONDICAO_PAGAMENTO: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Condição de pagamento')?.id,
                  FORMA_PAGAMENTO: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Forma de pagamento')?.id,
                  OBSERVACOES: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Observações do orçamento')?.id,
                });
                setEstimateValues({
                  valorUnitario: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Valor unitário')?.value?.toString().replaceAll('.', ','),
                  valorTotal: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Valor total')?.value?.toString().replaceAll('.', ','),
                  condicaoPagamento: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Condição de pagamento')?.value,
                  formaPagamento: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Forma de pagamento')?.value,
                  obsOrcamento: response?.body.details.serviceSubtypeDynamicFields.find(
                    (v) => v.name === 'Observações do orçamento')?.value,
                });
              } else {
                setEstimatesIds(
                  {
                    VALOR_UNITARIO: response?.body.details.serviceTypeDynamicFields.find(
                      (v) => v.name === 'Valor unitário')?.id,
                    VALOR_TOTAL: response?.body.details.serviceTypeDynamicFields.find(
                      (v) => v.name === 'Valor total')?.id,
                    CONDICAO_PAGAMENTO: response?.body.details.serviceTypeDynamicFields.find(
                      (v) => v.name === 'Condição de pagamento')?.id,
                    FORMA_PAGAMENTO: response?.body.details.serviceTypeDynamicFields.find(
                      (v) => v.name === 'Forma de pagamento')?.id,
                    OBSERVACOES: response?.body.details.serviceTypeDynamicFields.find(
                      (v) => v.name === 'Observações do orçamento')?.id,
                  },
                );
                setEstimateValues({
                  valorUnitario: response?.body.details.serviceTypeDynamicFields.find(
                    (v) => v.name === 'Valor unitário')?.value?.toString().replaceAll('.', ','),
                  valorTotal: response?.body.details.serviceTypeDynamicFields.find(
                    (v) => v.name === 'Valor total')?.value?.toString().replaceAll('.', ','),
                  condicaoPagamento: response?.body.details.serviceTypeDynamicFields.find(
                    (v) => v.name === 'Condição de pagamento')?.value,
                  formaPagamento: response?.body.details.serviceTypeDynamicFields.find(
                    (v) => v.name === 'Forma de pagamento')?.value,
                  obsOrcamento: response?.body.details.serviceTypeDynamicFields.find(
                    (v) => v.name === 'Observações do orçamento')?.value,
                });
              }
            }
          }
          if (response?.body.details.serviceRequestNotes) {
            setObsArray(response?.body.details.serviceRequestNotes);

            const test = JSON.parse(JSON.stringify(response?.body.details.serviceRequestNotes));

            setObsArrayInit(test);
          }

          if (response?.body.details.serviceSubtype) {
            loadSubtypeDynamicFields(
              response?.body.details.serviceSubtype.id,
              response?.body.details.landFields[0].culture === 'Cana açúc'
                ? '051'
                : null,
            );

            setHasSubType(true);
          } else {
            loadTypeDynamicFields(response?.body.details.serviceType.id);
            setHasSubType(false);
          }

          setCTCResponsavel(response?.body.details.ctc);
          setNomeFilial(response?.body.details.branchCoopercitrus.name);
          setServiceRequestFields(response?.body.details.serviceRequestFields);
          setDataAttachments(response?.body.details.attachments);
          setDataId(response?.body.details.id);
          setDataLandFields(response?.body.details.landFields);
          setDataLandName(response?.body.details.landName);
          setDataLandOwnerName(response?.body.details.landOwnerName);
          setDataMatriculationNumber(response?.body.details.matriculationNumber);
          setDataReasonForCancellation(response?.body.details.reasonForCancellation);
          setDataResponsableUser(response?.body.details.responsableUser);
          setResponsableUserBudgetName(response?.body.details.responsableUserBudgetName);
          setDataSchedulingDate(response?.body.details.schedulingDate);
          formInstance.setFieldsValue({
            schedulingDate: response?.body.details.schedulingDate?.value ? moment(response?.body.details.schedulingDate.value, 'YYYY-MM-DDTHH:mm:ss.SSSZZ').utc() : null,
          });
          setDataServiceName(response?.body.details.serviceName);
          setDataTelephone(response?.body.details.telephone);
          formInstance.setFieldsValue({ telephone: formatTelephone(response?.body.details.telephone) });
          setDataServiceSubtype(response?.body.details.serviceSubtype);
          setDataServiceType(response?.body.details.serviceType);

          const serviceFullName = `${response?.body.details.serviceName} ${(response?.body.details?.serviceType?.name) ? response?.body.details?.serviceType?.name : ''} ${(response?.body.details?.serviceSubtype?.name) ? response?.body.details?.serviceSubtype?.name : ''}`;

          setIsRestructured(isRestructuredService(serviceFullName));
          setDataServiceSubtypeDynamicFields(response?.body.details.serviceSubtypeDynamicFields);
          setDataServiceTypeDynamicFields(response?.body.details.serviceTypeDynamicFields);
          setDataSolicitationDateTime(response?.body.details.solicitationDateTime);
          setDataStatus(response?.body.details.status);
          setTechnicalDateAllocated(response?.body.details.technicalDateAllocated);
          setDataUserNameThatRequestedTheService(response?.body.details.userNameThatRequestedTheService);

          setLoading(false);
        } break;

        case (response?.body?.code === -5008):
          // "Service request not found", -5008
          notification.error({
            message: 'Erro',
            description: 'Solicitação de serviço não encontrada.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar os detalhes, tente novamente.',
          });
          break;
      }
    };

    if (getUserType() !== 'COOPERCITRUS') {
      navigate(`/service/detail/${id}`);
    }

    loadResponsableUser();
    loadData(id);
    loadStatusData(id);

    return () => {
      setLoading(false);
    };
  }, []);

  const getFormatedValues = (item, value) => {
    if (item.typeValue === 'BOOLEAN') {
      if (typeof value === 'boolean') {
        return value;
      }
      // Tipo grid volta uma array
      return !!value.length;
    }

    if (item.typeValue === 'DATE') {
      return moment(value).format(dateFormat);
    }

    return value;
  };

  const showModal = (value): void => {
    if ((
      dataStatus === 'Atendimento realizado'
      || dataStatus === 'Anexo de Relatório'
      || dataStatus === 'Em faturamento'
      || dataStatus === 'Concluído')
      && dataServiceName === 'Pós-vendas'
    ) {
      const uploadError = !uploadFilesReference.current.validateFiles();
      const uploadErrorAttachmentFiles = uploadAttachmentReports.current
        !== null ? !uploadAttachmentReports.current.validateFiles() : false;

      if (!uploadError && !uploadErrorAttachmentFiles) {
        setFormValueTemp(value);
        setVisibleModalResponsable(true);
      } else {
        message.error('Erro ao validar arquivo.');
      }
    } else {
      const uploadError = !uploadFilesReference.current.validateFiles();

      if (!uploadError) {
        setFormValueTemp(value);
        setVisibleModalResponsable(true);
      } else {
        message.error('Erro ao validar arquivo.');
      }
    }
  };

  const handleSubmit = async (values): Promise<unknown> => {
    try {
      const validationBudget = await validateBudgetValues();
    } catch (error) {
      setVisibleModalResponsable(false);
      const notificationArguments = {
        message: 'Notification Title',
        description: 'Description',
      };
      notificationArguments.message = 'AVISO';
      notificationArguments.description = 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.';
      notification.warning(notificationArguments);
      return error;
    }

    let finalValues;
    const paramsCooperEditNotes = [];
    const paramsCooperDeleteNotes = [];
    const paramsCooperAddNotes = [];

    for (const key in obsArrayInit) {
      if (!obsArray.some((a) => a.id === obsArrayInit[key].id)) {
        paramsCooperDeleteNotes.push({ id: obsArrayInit[key].id });
      }
    }

    for (const index in obsArray) {
      if (obsArrayInit.some((a) => a.id === obsArray[index].id)) {
        const obsContrl = obsArrayInit.filter((a) => a.id === obsArray[index].id)[0];
        const valText = formInstance.getFieldValue(`text${obsArray[index].id}`);
        if (
          valText !== obsArray[index].notes
          || obsContrl.privateNotes !== obsArray[index].privateNotes
        ) {
          obsArray[index].notes = valText;
          paramsCooperEditNotes.push(obsArray[index]);
        }
      } else {
        const valText = formInstance.getFieldValue(`text${obsArray[index].id}`);
        obsArray[index].notes = valText;
        obsArray[index].id = '';
        paramsCooperAddNotes.push(obsArray[index]);
      }
    }

    finalValues = await formInstance.validateFields();

    const uploadError = !uploadFilesReference.current.validateFiles();
    let uploadErrorAttachmentFiles = false;

    if ((
      dataStatus === 'Atendimento realizado'
      || dataStatus === 'Anexo de Relatório'
      || dataStatus === 'Em faturamento'
      || dataStatus === 'Concluído')
      && dataServiceName === 'Pós-vendas'
    ) {
      uploadErrorAttachmentFiles = uploadAttachmentReports.current !== null ? !uploadAttachmentReports.current.validateFiles() : false;

      if (!uploadErrorAttachmentFiles) {
        try {
          await uploadAttachmentReports.current.handleSubmitFiles();
        } catch (error) {
          setLoading(false);
          return;
        }
      }
    }

    const dataArrayDynamics = [];

    if (!isRestructured) {
      for (const ind in serviceTypeDynamicFields) {
        console.log(serviceTypeDynamicFields[ind]);
      }

      for (const ind in dataServiceSubtypeDynamicFields) {
        dataArrayDynamics.push(dataServiceSubtypeDynamicFields[ind]);
      }

      for (const ind in dataServiceTypeDynamicFields) {
        dataArrayDynamics.push(dataServiceTypeDynamicFields[ind]);
      }
    }

    let data;

    if (hasSubType) {
      data = {
        schedulingDate: dataSchedulingDate,
        serviceSubtypeDynamicFields: dataArrayDynamics,
      };
    } else {
      data = {
        schedulingDate: dataSchedulingDate,
        serviceTypeDynamicFields: dataArrayDynamics,
      };
    }

    setLoading(true);

    if (!uploadError) {
      try {
        await uploadFilesReference.current.handleSubmitFiles();
      } catch (error) {
        setLoading(false);
        return;
      }

      const params = {};
      params.serviceRequestId = id;

      if (paramsCooperEditNotes.length > 0) {
        const paramsEditRequest = {};
        paramsEditRequest.serviceRequestNotes = paramsCooperEditNotes;

        try {
          const editServiceRequestNotesReqRef: RequestWrapper = put({
            url: `/service/editServiceRequestNotes/${params.serviceRequestId}`,
            params: paramsEditRequest,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await editServiceRequestNotesReqRef;
        } catch (error) {
          setLoading(false);
          return;
        }
      }

      if (paramsCooperAddNotes.length > 0) {
        const paramsAddRequest = {};
        paramsAddRequest.serviceRequestNotes = paramsCooperAddNotes;

        try {
          const addServiceNotesRequestReference: RequestWrapper = post({
            url: `/service/addServiceRequestNotes/${params.serviceRequestId}`,
            params: paramsAddRequest,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await addServiceNotesRequestReference;
        } catch (error) {
          setLoading(false);
          return;
        }
      }

      if (paramsCooperDeleteNotes.length > 0) {
        const paramsDeleteRequest = {};
        paramsDeleteRequest.serviceRequestNotes = paramsCooperDeleteNotes;

        try {
          const deleteServiceRequestNotesReqRef: RequestWrapper = put({
            url: `/service/deleteServiceRequestNotes/${params.serviceRequestId}`,
            params: paramsDeleteRequest,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await deleteServiceRequestNotesReqRef;
        } catch (error) {
          setLoading(false);
          return;
        }
      }

      if (values.responsableUser) {
        params.responsableUserId = values.responsableUser;
      }

      if (values.telephone) {
        params.telephone = values.telephone.replace(/\D/g, '');
      }

      if (values.schedulingDate) {
        params.schedulingDate = {
          dynamicFieldId: data.schedulingDate.dynamicFieldId,
          id: data.schedulingDate.id,
          value: values.schedulingDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
        };
      }

      if (values.reasonForCancellation) {
        params.reasonForCancellation = values.reasonForCancellation;
      }

      const novoServiceTypeDynamicFields = [];

      if (!isRestructured) {
        serviceTypeDynamicFields.forEach((v) => {
          let value = formInstance.getFieldValue(`dynamicField${v.id}`);

          const dynamicField = data
            .serviceTypeDynamicFields
            .find((df) => df.dynamicFieldId === v.id);

          if (v.conditionComparison) {
            const referenceValue = formInstance.getFieldValue(`dynamicField${v.conditionFieldId}`);

            if (!testConditional(
              referenceValue,
              v.conditionComparison,
              v.conditionExpectedValue,
              v.typeValue,
            )) {
              value = undefined;
            }
          }

          if (value !== undefined
            || v.idCode.includes('VALOR_UNITARIO')
            || v.idCode.includes('VALOR_TOTAL')
            || v.idCode.includes('CONDICAO_PAGAMENTO')
            || v.idCode.includes('FORMA_PAGAMENTO')
            || v.idCode.includes('OBSERVACOES')
          ) {
            let canPush = true;
            if (v.idCode.includes('VALOR_UNITARIO')) {
              if (estimateValues.valorUnitario == formInstance.getFieldValue('valorUnitario')) {
                canPush = false;
              }
            } else if (v.idCode.includes('VALOR_TOTAL')) {
              if (estimateValues.valorTotal == formInstance.getFieldValue('valorTotal')) {
                canPush = false;
              }
            } else if (v.idCode.includes('CONDICAO_PAGAMENTO')) {
              if (estimateValues.condicaoPagamento == formInstance.getFieldValue('condicaoPagamento')) {
                canPush = false;
              }
            } else if (v.idCode.includes('FORMA_PAGAMENTO')) {
              if (estimateValues.formaPagamento == formInstance.getFieldValue('formaPagamento')) {
                canPush = false;
              }
            } else if (v.idCode.includes('OBSERVACOES')) {
              if (estimateValues.obsOrcamento == formInstance.getFieldValue('obsOrcamento')) {
                canPush = false;
              }
            }
            if (canPush) {
              novoServiceTypeDynamicFields.push({
                id: dynamicField ? dynamicField.id : null,
                dynamicFieldId: v.id,

                value: getFormatedValues(
                  v, formInstance.getFieldValue(`dynamicField${v.id}`),
                ),
              });
            }
          }
        });
      }

      const novoServiceSubtypeDynamicFields = [];

      if (!isRestructured) {
        serviceSubtypeDynamicFields.forEach((v) => {
          let value = formInstance.getFieldValue(`subtypeDynamicFields${v.id}`);

          const dynamicField = data
            .serviceSubtypeDynamicFields
            .find((df) => df.dynamicFieldId === v.id);

          if (v.conditionComparison) {
            const referenceValue = formInstance.getFieldValue(`subtypeDynamicFields${v.conditionFieldId}`);
            if (!testConditional(
              referenceValue,
              v.conditionComparison,
              v.conditionExpectedValue,
              v.typeValue,
            )) {
              value = undefined;
            }
          }

          if (value !== undefined
            || v.idCode.includes('VALOR_UNITARIO')
            || v.idCode.includes('VALOR_TOTAL')
            || v.idCode.includes('CONDICAO_PAGAMENTO')
            || v.idCode.includes('FORMA_PAGAMENTO')
            || v.idCode.includes('OBSERVACOES')
          ) {
            let canPush = true;
            if (v.idCode.includes('VALOR_UNITARIO')) {
              if (estimateValues.valorUnitario == formInstance.getFieldValue('valorUnitario')) {
                canPush = false;
              }
            } else if (v.idCode.includes('VALOR_TOTAL')) {
              if (estimateValues.valorTotal == formInstance.getFieldValue('valorTotal')) {
                canPush = false;
              }
            } else if (v.idCode.includes('CONDICAO_PAGAMENTO')) {
              if (estimateValues.condicaoPagamento == formInstance.getFieldValue('condicaoPagamento')) {
                canPush = false;
              }
            } else if (v.idCode.includes('FORMA_PAGAMENTO')) {
              if (estimateValues.formaPagamento == formInstance.getFieldValue('formaPagamento')) {
                canPush = false;
              }
            } else if (v.idCode.includes('OBSERVACOES')) {
              if (estimateValues.obsOrcamento == formInstance.getFieldValue('obsOrcamento')) {
                canPush = false;
              }
            }
            if (canPush) {
              novoServiceSubtypeDynamicFields.push({
                id: dynamicField ? dynamicField.id : null,
                dynamicFieldId: v.id,
                value: getFormatedValues(v, value),
              });
            }
          }
        });
      }

      params.serviceTypeDynamicFields = novoServiceTypeDynamicFields || [];
      params.serviceSubtypeDynamicFields = novoServiceSubtypeDynamicFields || [];

      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      if (isRestructured) {
        const fields = Object.entries(finalValues);
        params.serviceRequestFieldInputList = fields.map((fieldValue) => {
          let campoEncontrado = serviceRequestFields.find((val) => val.idCode === fieldValue[0]);
          let orcamento = false;
          if (fieldValue[0] == 'valorUnitario') {
            campoEncontrado = serviceRequestFields.find((val) => val.idCode.includes('VALOR_UNITARIO'));
            orcamento = true;
            if (campoEncontrado.value == formInstance.getFieldValue('valorUnitario')) {
              campoEncontrado.id = null;
            }
          }
          if (fieldValue[0] == 'valorTotal') {
            campoEncontrado = serviceRequestFields.find((val) => val.idCode.includes('VALOR_TOTAL'));
            orcamento = true;
            if (campoEncontrado.value == formInstance.getFieldValue('valorTotal')) {
              campoEncontrado.id = null;
            }
          }
          if (fieldValue[0] == 'condicaoPagamento') {
            campoEncontrado = serviceRequestFields.find((val) => val.idCode.includes('CONDICAO_PAGAMENTO'));
            orcamento = true;
            if (campoEncontrado.value == formInstance.getFieldValue('condicaoPagamento')) {
              campoEncontrado.id = null;
            }
          }
          if (fieldValue[0] == 'formaPagamento') {
            campoEncontrado = serviceRequestFields.find((val) => val.idCode.includes('FORMA_PAGAMENTO'));
            orcamento = true;
            if (campoEncontrado.value == formInstance.getFieldValue('formaPagamento')) {
              campoEncontrado.id = null;
            }
          }
          if (fieldValue[0] == 'obsOrcamento') {
            campoEncontrado = serviceRequestFields.find((val) => val.idCode.includes('OBSERVACOES'));
            orcamento = true;
            if (campoEncontrado.value == formInstance.getFieldValue('obsOrcamento')) {
              campoEncontrado.id = null;
            }
          }
          return ({
            idCode: orcamento ? (campoEncontrado?.idCode) : fieldValue[0],
            value: fieldValue[1],
            id: campoEncontrado?.id,
          });
        }).filter((fieldValue) => {
          return !(fieldValue.value == null && fieldValue.id == null);
        }).filter((fieldValue) => {
          return (
            (
              !fieldValue.idCode.includes('OBSERVACOES')
              && !fieldValue.idCode.includes('FORMA_PAGAMENTO')
              && !fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
              && !fieldValue.idCode.includes('VALOR_TOTAL')
              && !fieldValue.idCode.includes('VALOR_UNITARIO')
            ) || fieldValue.id != null
          );
        }).filter((fieldValue) => {
          return fieldValue.idCode.includes('GEOFERT')
            || fieldValue.idCode.includes('SPRAY_DRONE')
            || fieldValue.idCode.includes('VANT')
            || fieldValue.idCode.includes('SATELITE')
            || fieldValue.idCode.includes('APLICACAO_CORRETIVOS')
            || fieldValue.idCode.includes('OBSERVACOES')
            || fieldValue.idCode.includes('FORMA_PAGAMENTO')
            || fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
            || fieldValue.idCode.includes('VALOR_TOTAL')
            || fieldValue.idCode.includes('VALOR_UNITARIO');
        });
      }
      if (
        allRequestData?.serviceName?.toUpperCase() === 'GEOFERT'
        || allRequestData?.serviceName === 'Pós-vendas'
      ) {
        for (const ind in params.serviceRequestFieldInputList) {
          if (params.serviceRequestFieldInputList[ind].idCode.includes('VALOR_TOTAL')) {
            params.serviceRequestFieldInputList[ind].value = formInstance.getFieldValue('valorTotal');
          }
          if (params.serviceRequestFieldInputList[ind].idCode.includes('VALOR_UNITARIO')) {
            params.serviceRequestFieldInputList[ind].value = formInstance.getFieldValue('valorUnitario');
          }
          if (params.serviceRequestFieldInputList[ind].idCode.includes('CONDICAO_PAGAMENTO')) {
            params.serviceRequestFieldInputList[ind].value = formInstance.getFieldValue('condicaoPagamento');
          }
          if (params.serviceRequestFieldInputList[ind].idCode.includes('FORMA_PAGAMENTO')) {
            params.serviceRequestFieldInputList[ind].value = formInstance.getFieldValue('formaPagamento');
          }
          if (params.serviceRequestFieldInputList[ind].idCode.includes('OBSERVACOES')) {
            params.serviceRequestFieldInputList[ind].value = formInstance.getFieldValue('obsOrcamento');
          }
        }
      } else {
        if (dataServiceType.name === 'Aplicação em área de catação') {
          for (const ind in params.serviceSubtypeDynamicFields) {
            if (params.serviceSubtypeDynamicFields[ind].id == estimatesIds['VALOR_TOTAL']) {
              params.serviceSubtypeDynamicFields[ind].value = formInstance.getFieldValue('valorTotal');
            }
            if (params.serviceSubtypeDynamicFields[ind].id == estimatesIds['VALOR_UNITARIO']) {
              params.serviceSubtypeDynamicFields[ind].value = formInstance.getFieldValue('valorUnitario');
            }
            if (params.serviceSubtypeDynamicFields[ind].id == estimatesIds['CONDICAO_PAGAMENTO']) {
              params.serviceSubtypeDynamicFields[ind].value = formInstance.getFieldValue('condicaoPagamento');
            }
            if (params.serviceSubtypeDynamicFields[ind].id == estimatesIds['FORMA_PAGAMENTO']) {
              params.serviceSubtypeDynamicFields[ind].value = formInstance.getFieldValue('formaPagamento');
            }
            if (params.serviceSubtypeDynamicFields[ind].id == estimatesIds['OBSERVACOES']) {
              params.serviceSubtypeDynamicFields[ind].value = formInstance.getFieldValue('obsOrcamento');
            }
          }
        } else {
          for (const ind in params.serviceTypeDynamicFields) {
            if (params.serviceTypeDynamicFields[ind].id == estimatesIds['VALOR_TOTAL']) {
              params.serviceTypeDynamicFields[ind].value = formInstance.getFieldValue('valorTotal');
            }
            if (params.serviceTypeDynamicFields[ind].id == estimatesIds['VALOR_UNITARIO']) {
              params.serviceTypeDynamicFields[ind].value = formInstance.getFieldValue('valorUnitario');
            }
            if (params.serviceTypeDynamicFields[ind].id == estimatesIds['CONDICAO_PAGAMENTO']) {
              params.serviceTypeDynamicFields[ind].value = formInstance.getFieldValue('condicaoPagamento');
            }
            if (params.serviceTypeDynamicFields[ind].id == estimatesIds['FORMA_PAGAMENTO']) {
              params.serviceTypeDynamicFields[ind].value = formInstance.getFieldValue('formaPagamento');
            }
            if (params.serviceTypeDynamicFields[ind].id == estimatesIds['OBSERVACOES']) {
              params.serviceTypeDynamicFields[ind].value = formInstance.getFieldValue('obsOrcamento');
            }
          }
        }
      }

      try {
        const editServiceRequestReqRef: RequestWrapper = put({
          url: '/service/editServiceRequest',
          params,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await editServiceRequestReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      setLoading(false);

      switch (true) {
        case (response?.body?.code === 5013):
        case (response?.body?.code === 5002):
          // "Service request edited successfully", 5013
          // "Service requested successfully", 5002
          notification.success({
            message: 'Sucesso',
            description: 'Serviço editado com sucesso',
          });
          navigate(`/service/detail/${id}`);
          break;

        case (responseError?.body?.code === -5008):
          // "Service request not found", -5008
          notification.error({
            message: 'Erro',
            description: 'Solicitação de serviço não encontrada.',
          });
          break;

        case (responseError?.body?.code === -1007):
          // "User not found", -1007
          notification.error({
            message: 'Erro',
            description: 'Usuário não encontrado.',
          });
          break;

        case (responseError?.body?.code === -5014):
          // "Service request step dynamic field not found", -5014
          notification.error({
            message: 'Erro',
            description: 'Data de agendamento anterior não encontrada.',
          });
          break;

        case (responseError?.body?.code === -5015):
          // "Invalid reason for cancellation", -5015
          notification.error({
            message: 'Erro',
            description: 'Motivo de cancelamento inválido.',
          });
          break;

        case (responseError?.body?.code === -5023):
          // "Telephone can not be null", -5023
          notification.error({
            message: 'Erro',
            description: 'O campo telefone não pode ser vazio.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Erro ao atualizar o serviço.',
          });
          break;
      }
    } else {
      setLoading(false);
    }
  };

  const addObs = (): void => {
    setLoading(true);

    const ctrl = [];

    for (const key in obsArray) {
      ctrl.push(obsArray[key]);
    }

    let uniqueId = false;
    let newId;

    while (!uniqueId) {
      newId = Math.random();

      if (!generatedNumbers.some((a) => a === newId)) {
        uniqueId = true;
      }
    }

    ctrl.push(
      {
        notes: '',
        privateNotes: true,
        type: 'COOPERCITRUS',
        id: `${newId}temp`,
      },
    );

    generatedNumbers.push(newId);
    setObsArray(ctrl);
    setLoading(false);
  };

  const removeObs = (index): void => {
    setLoading(true);

    const ctrl = [];

    for (const key in obsArray) {
      ctrl.push(obsArray[key]);
    }

    ctrl.splice(index, 1);
    setObsArray(ctrl);
    setLoading(false);
  };

  const changeChecked = (index): void => {
    setLoading(true);

    const test = [];

    for (const key in obsArray) {
      test.push(obsArray[key]);
    }

    test[index].privateNotes = !test[index].privateNotes;
    setObsArray(test);
    setLoading(false);
  };

  const renderObs = (coopercitrus): JSX.Element => {
    const items = [];
    const b = obsArray;

    for (const index in obsArray) {
      if (
        (coopercitrus && obsArray[index].type === 'COOPERCITRUS')
        || (!coopercitrus && obsArray[index].type !== 'COOPERCITRUS')) {
        items.push(
          <Col
            className="colObs"
          >
            <Row>
              <Form.Item
                label=""
                name={`text${obsArray[index].id}`}
                initialValue={obsArray[index].notes}
                shouldUpdate
                rules={[
                  {
                    required: true, message: 'Não é possível adicionar uma observação vazia',
                  },
                  {
                    max: 1000, message: 'O número máximo de caracteres pra observações é de 1000',
                  },
                ]}
              >
                <TextArea
                  className="obsCooper"
                  xs={{ span: 24 }}
                  lg={{ span: 24 }}
                  rows={4}
                  value={b[index].notes}
                  disabled={!coopercitrus}
                />
              </Form.Item>
            </Row>
            {
              obsArray[index].type === 'COOPERCITRUS' && (
                <Row
                  justify="space-between"
                  className="RowPrivado"
                >
                  <Row
                    style={{ cursor: 'pointer' }}
                    onClick={obsArray[index].type === 'COOPERCITRUS' ? (): void => changeChecked(index) : (): void => {}}
                  >
                    <Form.Item
                      label=""
                      name={`check${index}`}
                    >
                      <Checkbox
                        checked={obsArray[index].privateNotes}
                      />
                    </Form.Item>
                    <div
                      className="privadoText"
                    >
                      <p>
                        Privado
                      </p>
                    </div>
                  </Row>
                  <DeleteFilled
                    className="deleteControl"
                    onClick={obsArray[index].type === 'COOPERCITRUS' ? (): void => removeObs(index) : (): void => {}}
                  />
                </Row>
              )
            }
          </Col>,
        );
      }
    }

    return (
      <Col>
        {items}
      </Col>
    );
  };

  const acceptedOrRefusalTechnician = async (accepted): Promise<void> => {
    const paramsEditRequest = {};

    paramsEditRequest.accepted = accepted;
    paramsEditRequest.serviceRequestId = id;

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    if (!accepted) {
      Modal.confirm({
        title: 'Motivo de recusa',

        content: (
          <Form form={formInstanceReason}>
            <Form.Item
              name="reason"
              rules={[
                {
                  required: true,
                  message: 'Por favor, insira um motivo.',
                },
              ]}
            >
              <Input.TextArea
                placeholder="Motivo de recusa"
                rows={4}
              />
            </Form.Item>
          </Form>
        ),

        okText: 'Confirmar',
        cancelText: 'Cancelar',
        autoFocusButton: null,
        icon: (<WarningOutlined />),

        onOk: async () => {
          let valueReason;

          if (await formInstanceReason.validateFields()) {
            try {
              valueReason = await formInstanceReason.validateFields();
              paramsEditRequest.note = valueReason.reason;

              try {
                const acceptedOrRefusalTechnicianReqRef: RequestWrapper = put({
                  url: '/service/acceptedOrRefusalTechnician',
                  params: paramsEditRequest,

                  frontConfigs: {
                    navigateFunction: navigate,
                  },
                });

                response = await acceptedOrRefusalTechnicianReqRef;
              } catch (error) {
                if (isSuperAgentError(error)) {
                  responseError = error.response;
                } else {
                  genericError = error as Error;
                }
              }

              setLoading(false);

              switch (true) {
                case (response?.body?.code === 5019):
                case (response?.body?.code === 5020):
                  // "After sales service successfully accepted", 5019
                  // "After sales service successfully refused", 5020
                  notification.success({
                    message: 'Sucesso',
                    description: 'Serviço editado com sucesso.',
                  });
                  navigate(`/service/detail/${id}`);
                  break;

                case (responseError?.body?.code === -5008):
                  // "Service request not found", -5008
                  notification.error({
                    message: 'Erro',
                    description: 'Solicitação de serviço não encontrada.',
                  });
                  break;

                case (responseError?.body?.code === -5033):
                  // "Responsible user cannot be null", -5033
                  notification.error({
                    message: 'Erro',
                    description: 'Usuário responsável não pode estar vazio.',
                  });
                  break;

                case (responseError?.body?.code === -5034):
                  // "Mandatory refusal reason", -5034
                  notification.error({
                    message: 'Erro',
                    description: 'Motivo de recusa é obrigatório.',
                  });
                  break;

                case (responseError?.body?.code === -4001):
                  // "You must be authenticated to perform this operation", -4001
                  break;

                case (responseError?.body?.code === -4003):
                  // "You do not have permission to perform this operation", -4003
                  notification.error({
                    message: 'Erro',
                    description: 'Desculpe, você não possui permissão para executar esta ação.',
                  });
                  break;

                case (genericError?.message?.includes('has been aborted')):
                  // dont show anything when request is aborted
                  break;

                case (responseError?.body?.code === -4000):
                default:
                  // "Something unexpected happened", -4000
                  notification.error({
                    message: 'Erro',
                    description: 'Erro ao atualizar o serviço.',
                  });
                  break;
              }
            } catch (error) {
              return;
            }
          }
        },
      });
    } else {
      try {
        const acceptedOrRefusalTechnicianReqRef = put({
          url: '/service/acceptedOrRefusalTechnician',
          params: paramsEditRequest,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await acceptedOrRefusalTechnicianReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      setLoading(false);

      switch (true) {
        case (response?.body?.code === 5019):
        case (response?.body?.code === 5020):
          // "After sales service successfully accepted", 5019
          // "After sales service successfully refused", 5020
          notification.success({
            message: 'Sucesso',
            description: 'Serviço editado com sucesso.',
          });
          navigate(`/service/detail/${id}`);
          break;

        case (responseError?.body?.code === -5008):
          // "Service request not found", -5008
          notification.error({
            message: 'Erro',
            description: 'Solicitação de serviço não encontrada.',
          });
          break;

        case (responseError?.body?.code === -5033):
          // "Responsible user cannot be null", -5033
          notification.error({
            message: 'Erro',
            description: 'Usuário responsável não pode estar vazio.',
          });
          break;

        case (responseError?.body?.code === -5034):
          // "Mandatory refusal reason", -5034
          notification.error({
            message: 'Erro',
            description: 'Motivo de recusa é obrigatório.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Erro ao atualizar o serviço.',
          });
          break;
      }
    }
  };

  const validateSchedulingDate = (rule, value): Promise<void> => {
    if (!value) {
      return Promise.reject(new Error('Por favor, insira data de agendamento.'));
    }

    if (moment(value).endOf('day') <= moment().endOf('day')) {
      return Promise.reject(new Error(`Insira uma data maior que ${moment().format(dateFormat)}`));
    }

    return Promise.resolve();
  };

  const renderDynamicField = (field): JSX.Element => {
    let fieldData;

    if (field.conditionFieldId) {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
    } else {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.name === field.name);
    }

    if (!fieldData) {
      if (field.conditionFieldId) {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
      } else {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.name === field.name);
      }
    }

    if (!fieldData) {
      fieldData = {
        value: undefined,
      };
    }

    return (
      <DynamicFields
        field={{ ...fieldData, ...field }}
        form={formInstance}
        type="dynamicField"
        key={`type-${field.id}`}
        edit={true}
      />
    );
  };

  const renderSubtypeDynamicField = (field): JSX.Element => {
    let fieldData;

    if (field.conditionFieldId) {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
    } else {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.name === field.name);
    }

    if (!fieldData) {
      if (field.conditionFieldId) {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
      } else {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.name === field.name);
      }
    }

    if (!fieldData) {
      fieldData = {
        value: undefined,
      };
    }

    return (
      <DynamicFields
        field={{ ...fieldData, ...field }}
        form={formInstance}
        type="subtypeDynamicFields"
        key={`type-${field.id}`}
        edit={true}
      />
    );
  };

  return (
    <div className="EditService">
      <Spin
        tip="Carregando..."
        spinning={loading}
      >
        <Form
          scrollToFirstError
          form={formInstance}
          layout="vertical"
          onFinish={(value): void => showModal(value)}
          onFinishFailed={
            (errorInfo): void => {
              console.log('EditService onFinishFailed', errorInfo);
            }
          }
        >
          <Row
            gutter={24}
          >
            <Col
              xs={{ span: 24 }}
              lg={{ span: 14 }}
            >
              <span
                className="service-title"
              >
                Detalhes da solicitação
              </span>
            </Col>
            <Col
              xs={{ span: 24 }}
              lg={{ span: 10 }}
            >
              <div
                className="buttons-container"
              >
                <Row
                  gutter={24}
                >
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                  >
                    <Button
                      className="btn-previous"
                      onClick={
                        (): void => navigate(`/service/detail/${id}`)
                      }
                    >
                      Voltar
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                  >
                    <Form.Item
                      noStyle
                    >
                      <Button
                        className="btn-edit"
                        type="primary"
                        htmlType="submit"
                      >
                        Salvar
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <div
            className="inner-container"
          >
            <Row
              gutter={24}
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 11 }}
              >
                <div>
                  <Row
                    gutter={24}
                  >
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Data/hora da solicitação
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {
                          (dataSolicitationDateTime
                            ? moment(dataSolicitationDateTime)
                              .format('DD/MM/YYYY [às] HH:mm') : '')
                        }
                      </p>
                    </Col>
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Serviço/tipo de serviço
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {dataServiceName}
                        {!!dataServiceType && `: ${dataServiceType.name}`}
                      </p>
                    </Col>
                  </Row>

                  <Row
                    gutter={24}
                  >
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Filial
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {nomeFilial ? nomeFilial : '-'}
                      </p>
                    </Col>
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        CTC responsável
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {ctcResponsavel ? ctcResponsavel : '-'}
                      </p>
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Usuário que solicitou
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {dataUserNameThatRequestedTheService}
                      </p>
                    </Col>

                    {
                      userType === 'COOPERCITRUS'
                      && (
                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            className="item-title"
                          >
                            Usuário responsável
                          </p>
                          <Form.Item
                            label=""
                            name="responsableUser"
                            rules={[]}
                            initialValue={
                              dataResponsableUser
                                ? dataResponsableUser?.id?.toString()
                                : undefined
                            }
                          >
                            <Select
                              showSearch
                              allowClear
                              style={{ width: '100%' }}
                              placeholder="Selecione o usuário responsável"
                              filterOption={
                                (input, option) => option
                                  .props
                                  .children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              {userOptions}
                            </Select>
                          </Form.Item>
                        </Col>
                      )
                    }

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Status
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {dataStatus}
                      </p>
                    </Col>

                    {
                      dataSchedulingDate && dataStatus === 'Agendado'
                        ? (
                          <Col
                            xs={{ span: 12 }}
                            lg={{ span: 12 }}
                          >
                            <p
                              className="item-title"
                            >
                              <span
                                className="field-required-symbol"
                              >
                                *
                              </span>
                              Data do agendamento
                            </p>
                            <Form.Item
                              label=""
                              name="schedulingDate"
                              rules={[{ validator: validateSchedulingDate }]}
                              initialValue={
                                dataSchedulingDate.value != '' && dataSchedulingDate.value != null
                                  ? moment(dataSchedulingDate.value, 'YYYY-MM-DDTHH:mm:ss.SSSZZ')
                                  : null
                              }
                            >
                              <DatePicker
                                style={{ width: '100%' }}
                                placeholder="Data de agendamento"
                                format="DD/MM/YYYY"
                              />
                            </Form.Item>
                          </Col>
                        )
                        : null
                    }

                    {
                      dataSchedulingDate
                        ? (
                          <Col
                            xs={{ span: 12 }}
                            lg={{ span: 12 }}
                          >
                            <p
                              className="item-title"
                            >
                              Data do agendamento
                            </p>
                            <p
                              className="item-descripetion"
                            >
                              {moment(dataSchedulingDate.value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').format('DD/MM/YYYY')}
                            </p>
                          </Col>
                        )
                        : null
                    }
                  </Row>

                  <Row
                    className="param-row"
                  >
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title item-title-required"
                      >
                        Telefone para contato
                      </p>

                      {(
                        getUserType() !== 'COOPERCITRUS'
                          ? (
                            <p>
                              {dataTelephone}
                            </p>
                          )
                          : (
                            <Form.Item
                              label=""
                              name="telephone"
                              validateTrigger={['onBlur']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Por favor, insira um telefone.',
                                },
                                {
                                  min: 14,
                                  message: 'Telefone inválido',
                                },
                              ]}
                            >
                              <MaskedInput
                                guide={false}
                                mask={mask}
                                placeholder="(00) 00000-0000"
                                className="ant-input"
                                maxLength={15}
                              />
                            </Form.Item>
                          )
                      )}
                    </Col>
                  </Row>

                  {
                    dataReasonForCancellation
                    && (
                      <Row
                        gutter={24}
                      >
                        <Col
                          xs={{ span: 24 }}
                          lg={{ span: 24 }}
                        >
                          <p
                            className="item-title"
                          >
                            Motivo do cancelamento
                          </p>
                          <Form.Item
                            label=""
                            name="reasonForCancellation"
                            rules={[
                              { required: true, message: 'Por favor, insira o motivo do cancelamento' },
                              { max: 200, message: 'Máximo de 200 caracteres' },
                            ]}
                            initialValue={dataReasonForCancellation}
                          >
                            <Input.TextArea
                              placeholder="Motivo do cancelamento"
                              rows={4}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )
                  }

                  <Row
                    className="param-row"
                  >
                    <Col>
                      <p
                        className="item-title"
                      >
                        Informações adicionais
                      </p>
                      Matrícula:&nbsp;
                      {dataMatriculationNumber}
                    </Col>
                  </Row>

                  <Row
                    className="param-row"
                  >
                    <Col>
                      Cooperado:&nbsp;
                      {dataLandOwnerName}
                    </Col>
                  </Row>

                  <Row
                    className="param-row"
                  >
                    <Col>
                      {
                        (dataLandName
                          ? (
                            `Propriedade: ${dataLandName}`
                          )
                          : 'Propriedade: -'
                        )
                      }
                    </Col>
                  </Row>

                  {
                    serviceTypeDynamicFields.length > 0
                      && !isRestructured
                      ? (
                        <div
                          style={{ marginTop: 15 }}
                        >
                          {serviceTypeDynamicFields.filter((f) => f.name !== 'Valor unitário'
                            && f.name !== 'Valor total'
                            && f.name !== 'Condição de pagamento'
                            && f.name !== 'Forma de pagamento'
                            && f.name !== 'Observações do orçamento',
                          ).map(renderDynamicField)}
                        </div>
                      )
                      : null
                  }

                  {
                    dataServiceSubtype?.name
                    && (
                      <Row
                        className="param-row"
                        style={{ marginTop: 15 }}
                      >
                        <Col>
                          Tipo:
                          <span style={{ float: 'right' }}>
                            {dataServiceSubtype.name}
                          </span>
                        </Col>
                      </Row>
                    )
                  }

                  {
                    (dataServiceType && dataServiceType.id !== 2)
                      && !isRestructured
                      ? serviceSubtypeDynamicFields.filter((f) => f.name !== 'Valor unitário'
                        && f.name !== 'Valor total'
                        && f.name !== 'Condição de pagamento'
                        && f.name !== 'Forma de pagamento'
                        && f.name !== 'Observações do orçamento',
                      ).map(renderSubtypeDynamicField)
                      : (
                        <GridFields
                          form={formInstance}
                          data={dataShare}
                        />
                      )
                  }
                </div>

                {
                  isRestructured
                    ? (
                      <Row
                        gutter={[24, 24]}
                        className="EditService__RequestFieldsRowContainer"
                      >
                        <Col
                          xs={{ span: 24 }}
                        >
                          <ServiceRequestFieldsRenderer
                            detail={true}
                            edit={true}
                            formInstance={formInstance}
                            serviceName={dataServiceName}
                            serviceTypeName={dataServiceType.name}
                            serviceSubTypeName={dataServiceSubtype?.name}
                            labelClassName="EditService__RequestFieldLabel"
                            initialValuesObject={
                              Object.fromEntries(
                                serviceRequestFields.map(
                                  (val) => {
                                    return [val.idCode, val.value];
                                  },
                                ),
                              )
                            }
                            allRequestParams={{
                              attachments: allRequestData.attachments,
                              id: allRequestData.id,
                              landFields: allRequestData.landFields,
                              landName: allRequestData.landName,
                              landOwnerName: allRequestData.landOwnerName,
                              matriculationNumber: allRequestData.matriculationNumber,
                              reasonForCancellation: allRequestData.reasonForCancellation,
                              responsableUser: allRequestData.responsableUser,
                              schedulingDate: allRequestData.schedulingDate,
                              serviceName: allRequestData.serviceName,
                              serviceRequestFields: allRequestData.serviceRequestFields,
                              serviceRequestNotes: allRequestData.serviceRequestNotes,
                              serviceSubtype: allRequestData.serviceSubtype,
                              serviceSubtypeDynamicFields:
                                allRequestData.serviceSubtypeDynamicFields,
                              serviceSubtypeName: allRequestData.serviceSubtypeName,
                              serviceType: allRequestData.serviceType,
                              serviceTypeDynamicFields: allRequestData.serviceTypeDynamicFields,
                              serviceTypeName: allRequestData.serviceTypeName,
                              solicitationDateTime: allRequestData.solicitationDateTime,
                              status: allRequestData.status,
                              telephone: allRequestData.telephone,
                              userNameThatRequestedTheService:
                                allRequestData.userNameThatRequestedTheService,
                            }}
                          />
                        </Col>
                      </Row>
                    )
                    : null
                }
              </Col>
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12, offset: 1 }}
                style={{ paddingTop: 15 }}
              >
                {
                  dataServiceName !== 'Pós-vendas'
                    ? (
                      <SelectedLands
                        talhoesSelecionados={
                          dataLandFields.map(
                            (v) => ({
                              ...v,
                              culture: {
                                description: v.culture,
                              },
                            }),
                          )
                        }
                      />
                    )
                    : null
                }

                <div
                  className="attachments-container"
                >
                  <Row
                    className="param-row"
                  >
                    <div
                      className="field-title-text"
                      style={{ marginBottom: 8 }}
                    >
                      Anexos
                    </div>
                  </Row>
                  <div
                    className="attachments-items-container"
                  >
                    <UploadFiles
                      typeUser="SERVICE_REQUEST_COOPERCITRUS_FILE"
                      ref={uploadFilesReference}
                      origin="edit"
                      requestType="SERVICO"
                      id={dataId}
                      fileSize={valueAttachmentSizeCoopercitrus.current}
                      action="edit"
                      serviceAction=""
                      initialFiles={
                        dataAttachments.map((item) => ({ ...item, uid: item.id, status: 'done' }))
                      }
                    />
                  </div>
                </div>
                {
                  dataResponsableUser != null
                  && dataResponsableUser.id == userId
                  && dataStatus == 'Agendado'
                  && dataServiceName == 'Pós-vendas'
                  && technicalDateAllocated == null
                  && (
                    <Row
                      gutter={24}
                    >
                      <Col
                        xs={{ span: 24 }}
                        lg={{ span: 15 }}
                      >
                        <div
                          className="buttons-container"
                        >
                          <Row
                            gutter={24}
                          >
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 12 }}
                            >
                              <Button
                                className="btn-previous"
                                onClick={(): void => { acceptedOrRefusalTechnician(false); }}
                              >
                                Recusar
                              </Button>
                            </Col>
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 12 }}
                            >
                              <Form.Item
                                noStyle
                              >
                                <Button
                                  className="btn-edit"
                                  type="primary"
                                  onClick={(): void => { acceptedOrRefusalTechnician(true); }}
                                >
                                  Aceitar
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  )
                }

                {
                  (dataStatus === 'Atendimento realizado'
                    || dataStatus === 'Anexo de Relatório'
                    || dataStatus === 'Em faturamento'
                    || dataStatus === 'Concluído')
                    && dataServiceName === 'Pós-vendas'
                    ? (
                      <div
                        className="attachments-container"
                      >
                        <Row
                          className="param-row"
                        >
                          <div
                            className="field-title-text"
                            style={{ marginBottom: 8 }}
                          >
                            Anexos de relatório
                          </div>
                        </Row>
                        <div
                          className="attachments-items-container"
                        >
                          <UploadFiles
                            typeUser="REPORT_ATTACHMENT"
                            ref={uploadAttachmentReports}
                            origin="edit"
                            requestType="SERVICO"
                            id={dataId}
                            fileSize={valueAttachmentSizeCoopercitrus.current}
                            action="edit"
                            serviceStatus={dataStatus}
                            serviceAction="Pós-vendas"
                            initialFiles={
                              dataAttachments.map((item) => ({ ...item, uid: item.id, status: 'done' }))
                            }
                          />

                          {
                            dataStatus === 'Atendimento realizado'
                              ? (
                                <Alert
                                  className="top-alert"
                                  message="Após a confirmação da inserção do relatório de serviços o status desse serviço mudará para 'Anexo de Relatório'."
                                  type="warning"
                                />
                              )
                              : null
                          }
                          {
                            dataStatus === 'Anexo de Relatório'
                              ? (
                                <Alert
                                  className="top-alert"
                                  message="Ao remover todos os anexos de relatório o status do serviço retornará para 'Atendimento Realizado'."
                                  type="warning"
                                />
                              )
                              : null
                          }
                        </div>
                      </div>
                    )
                    : null
                }
                {
                  !allRequestData?.budgetId && userType === 'COOPERCITRUS'
                  && estimatesIds?.VALOR_UNITARIO
                  != null && (
                    <div>
                      <Row
                        gutter={24}
                      >
                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            className="item-title"
                          >
                            Usuário responsável pelo orçamento:
                          </p>
                          <p
                            className="item-descripetion"
                          >
                            {responsableUserBudgetName}
                          </p>
                        </Col>
                      </Row>
                      <br />
                      <Row gutter={24} style={{ backgroundColor: '#f7f9fa', padding: '.7rem' }}>
                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                            className="item-title item-title"
                          >
                            Valor unitário
                          </p>

                          <Form.Item
                            label=""
                            name="valorUnitario"
                          >
                            <CurrencyInput
                              className="ant-input"
                              decimalSeparator=","
                              thousandSeparator="."
                              placeholder="0,00"
                              step={0.01}
                              data-id="1"
                              min={0}
                              disabled={!emptyValues}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                            className="item-title item-title"
                          >
                            Valor total
                          </p>

                          <Form.Item
                            label=""
                            name="valorTotal"
                          >
                            <CurrencyInput
                              className="ant-input"
                              decimalSeparator=","
                              thousandSeparator="."
                              placeholder="0,00"
                              step={0.01}
                              data-id="1"
                              min={0}
                              disabled={!emptyValues}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                            className="item-title item-title"
                          >
                            Condição de pagamento
                          </p>

                          <Form.Item
                            label=""
                            name="condicaoPagamento"
                          >
                            <Input
                              placeholder="Insira uma condição de pagamento"
                              type="text"
                              maxLength="254"
                              className="ant-input"
                              disabled={!emptyValues}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                            className="item-title item-title"
                          >
                            Forma de pagamento
                          </p>

                          <Form.Item
                            label=""
                            name="formaPagamento"
                          >
                            <Input
                              placeholder="Insira uma forma de pagamento"
                              type="text"
                              maxLength="254"
                              className="ant-input"
                              disabled={!emptyValueObs || !emptyValues}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          xs={{ span: 24 }}
                          lg={{ span: 24 }}
                        >
                          <p
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                            className="item-title"
                          >
                            Observações do orçamento
                          </p>

                          <Form.Item
                            label=""
                            name="obsOrcamento"
                          >
                            <Input.TextArea
                              type="text"
                              maxLength="1499"
                              className="ant-input"
                              disabled={!emptyValueObs || !emptyValues}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  )
                }
              </Col>
            </Row>
            <Row
              className="param-row"
            >
              <Col>
                <p
                  className="item-title"
                >
                  Observações
                </p>
              </Col>
            </Row>
            <Row>
              {
                userType === 'COOPERCITRUS'
                && renderObs(false)
              }
            </Row>
            <Row
              className="param-row"
            >
              <Col>
                <p
                  className="item-title"
                >
                  Observações da Coopercitrus
                </p>
              </Col>
            </Row>
            <Row>
              {
                userType === 'COOPERCITRUS'
                && renderObs(true)
              }
            </Row>
            <Row>
              <Button
                className="btn-previous"
                onClick={addObs}
              >
                Adicionar observações
              </Button>
            </Row>
          </div>
          <Modal
            wrapClassName="EditService-status-modal"
            width={1000}
            title={<h3 style={{ margin: 0 }}>Status da solicitação</h3>}
            visible={visibleModalStatus}
            onCancel={(): void => { setVisibleModalStatus(false); }}
            footer={[]}
          >
            {
              // destroys element if not active
              visibleModalStatus
              && (
                <ServiceStatusComponent
                  loading={false}
                  statusesList={statusesList}
                  currentStatusIndex={currentStatusIndex}
                  canceled={canceled}
                />
              )
            }
          </Modal>
        </Form>
      </Spin>
      <Modal
        wrapClassName="editService-user-modal"
        title={(
          <h3
            style={{ margin: 0 }}
          >
            Deseja mesmo continuar
          </h3>
        )}
        visible={visibleModalResponsable}
        okText="Sim, prosseguir"
        cancelText="Não, quero revisar"
        onOk={
          (): void => {
            handleSubmit(formValueTemp);
          }
        }
        onCancel={
          (): void => {
            setVisibleModalResponsable(false);
          }
        }
      >
        <p>
          {`Ao prosseguir, as observações Coopercitrus que tenham sido adicionadas com a opção
          “Privada” desmarcada, serão exibidas e notificadas para o cooperado. Deseja mesmo
          continuar?`}
        </p>
      </Modal>
    </div>
  );
};

EditService.propTypes = {};

EditService.defaultProps = {};

export default EditService;